
const homeschema = {
  "@context": "https://schema.org",
  "@type":["Organization", "ProfessionalService"],
  "@id": "https://utilitarianlabs.com/#organization",
    "brand": {
    "@type": "Brand",
    "name": "Utilitarian Labs"
  },
  "name": "Utilitarian Labs Private Limited",
  "url": "https://utilitarianlabs.com/",
  "logo": "https://utilitarianlabs.com/images/logo.webp",
  "image": "https://utilitarianlabs.com/images/logo.webp",
   "description": "Salesforce Summit Partner specializing in Salesforce implementation, consulting, digital transformation, web and mobile app development.",


  "telephone": "+91 99107 70310",
  "foundingDate": "2019",
"areaServed": [
  {
    "@type": "Place",
    "name": "Worldwide"
  },
  {
    "@type": "Place",
    "name": "India"
  },
  {
    "@type": "Place",
    "name": "United States"
  },
  {
    "@type": "Place",
    "name": "United Kingdom"
  },
  {
    "@type": "Place",
    "name": "United Arab Emirates"
  },
  {
    "@type": "Place",
    "name": "Europe"
  },
  {
    "@type": "Place",
    "name": "APAC"
  }
]
,

  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+91 99107 70310",
    "contactType": "Sales",
    "areaServed": "IN",
    "availableLanguage": ["English"]
  },


  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Ground Floor, Vakil Square,  Bannerghatta Rd, KEB Colony, New Gurappana Palya, Jayanagara 9th Block, BTM Layout, Bengaluru, Karnataka ",
    "addressLocality": "Bengaluru",
    "addressRegion": "Karnataka",
    "postalCode": "560029",
    "addressCountry": "IN"
  },

  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 12.9198336,
    "longitude": 77.6008921
  },

  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday"
    ],
    "opens": "09:00",
    "closes": "18:00"
  },

  "sameAs": [
     "https://utilitarianlabs.com",
    "https://www.linkedin.com/company/utilitarianlabs",
    "https://www.instagram.com/utilitarian_labs",
    "https://youtube.com/@utilitarianlabs2015"
  ]
};

export default homeschema;
